__turbopack_context__.v({
  "body": "style-module-scss-module__cxAbfG__body",
  "container": "style-module-scss-module__cxAbfG__container",
  "errorLabel": "style-module-scss-module__cxAbfG__errorLabel",
  "input": "style-module-scss-module__cxAbfG__input",
  "label": "style-module-scss-module__cxAbfG__label",
});
